import { inject } from 'mobx-react';
import * as React from 'react';
import ESDataTableWithHeader from 'src/common/ESDataTableWithHeader';
import IDataTableManager from 'src/common/IDataTableManager';
import { DefaultKpi, IKpi } from 'src/Definitions';
import { IStores } from 'src/Stores';
import KpiDialog from './KpiDialog';

interface IKpisProps {
    dataTableManager?: IDataTableManager<IKpi>;
    disableKpi?: (kpi: IKpi) => void;
    getColumnSettingsAndKpis?: () => void;
    isModalOpen?: boolean;
    openDialogWithKpi?: (kpi: IKpi) => void;
    recoverKpi?: (kpi: IKpi) => void;
}

@inject((stores: IStores) => ({
    dataTableManager: stores.kpis.dataTableStore,
    disableKpi: stores.kpis.disableKpi,
    getColumnSettingsAndKpis: stores.kpis.getColumnSettingsAndKpis,
    isModalOpen: stores.kpis.isModalOpen,
    openDialogWithKpi: stores.kpis.openDialogWithKpi,
    recoverKpi: stores.kpis.recoverKpi,
}))
class Kpis extends React.Component<IKpisProps> {
    public componentDidMount() {
        this.props.getColumnSettingsAndKpis!();
    }

    public render() {
        const kpiDialog = this.props.isModalOpen && <KpiDialog />;
        return (
            <>
                <ESDataTableWithHeader
                    dataTableManager={this.props.dataTableManager!}
                    enableEdit={true}
                    enableReorderColumns={true}
                    enableSearch={true}
                    enableShowInactives={true}
                    enableToggleColumns={true}
                    openDialog={this.openDialog(DefaultKpi(true))}
                    title="KPI's"
                />
                {kpiDialog}
            </>
        );
    }

    public openDialog = (kpi: IKpi) => () => {
        this.props.openDialogWithKpi!(kpi);
    };
}

export default Kpis;



// WEBPACK FOOTER //
// ./src/kpis/Kpis.tsx